<!-- per problemi di referenze circolari con i servizi di i18n, ora il dialogo usa direttamente i caratteri aggiunti dal pipe di traduzione -->
<span matDialogTitle>{{ '\u200B' + dialogTitle + '\u200B' }}</span>
<button mat-icon-button matDialogClose (click)="onNoClick()">
  <mat-icon> close </mat-icon>
</button>
<mat-dialog-content>
  @if (data().title) {
    <div class="flex justify-start w-full">
      <span [innerHTML]="'\u200B' + data().title + '\u200B'"></span>
    </div>
  }
  @if (data().description) {
    <div class="flex justify-start w-full">
      <span>{{ '\u200B' + data().description + '\u200B' }}</span>
    </div>
  }
  @if (data().htmlContent) {
    <div
      class="flex justify-start w-full"
      [innerHTML]="data().htmlContent"
    ></div>
  }
</mat-dialog-content>
<div matDialogActions align="end">
  <button
    mat-button
    (click)="onYesClick()"
    [class]="data().negativeMeaning ? 'error' : ''"
    [autofocus]="true"
  >
    {{ '\u200B' + yesLabel + '\u200B' }}
  </button>
  @if (!data().hideNo) {
    <button mat-button (click)="onNoClick()" class="button-grey">
      {{ '\u200B' + noLabel + '\u200B' }}
    </button>
  }
</div>
